<template>
  <div :class="{ page: true, 'ma-2': $store.state.ui.os.isPC }">
    <!-- <div v-if="$store.state.ui.os.isPC" ref="filters" style="width: 27vw;">
      <v-chip-group
        :show-arrows="true"
        active-class="primary--text"
      >
        <v-chip
          v-for="(tag, index) in tags"
          :key="tag"
          @click="selectTag(index)"
        >
          {{ tag }}
        </v-chip>
      </v-chip-group>
    </div> -->
    <template v-if="$store.state.ui.os.isPC">
      <div
        ref="swiper"
        class="swiper-gallery"
        :style="`height:${$store.state.ui.size.tabHeight - 16 - filtersHeight}px;`"
      >
        <div ref="container" class="swiper-wrapper"></div>
      </div>
    </template>
    <template v-else>
      <div ref="swiper" class="swiper-gallery swiper-gallery-phone">
        <div ref="container" class="swiper-wrapper"></div>
      </div>
    </template>
    <v-dialog v-model="$store.state.ui.showFilters" max-width="500">
      <v-card style="max-height: 50vh;overflow-y: auto;" class="pa-2">
        <v-btn absolute icon style="top: 0;right: 0;z-index: 1;" @click="$store.state.ui.showFilters = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-chip-group
          column
          mandatory
          active-class="primary--text"
        >
          <v-chip
            v-for="(tag, index) in tags"
            :key="tag"
            @click="selectTag(index)"
          >
            {{ tag }}
          </v-chip>
        </v-chip-group>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swiper from 'swiper'
var this_ = null
export default {
  name: 'SwiperGallery',
  data () {
    return {
      parentHeight: 0,
      showEmoji: false,
      swiper: null,
      lastGalleryIndex: -1,
      selectedTagIndex: 0,
      filtersHeight: 0
    }
  },
  components: {},
  props: {
    row: {
      type: Number,
      default: 2
    }
  },
  watch: {
    '$store.state.brand.loadJsonComplete': function () {
      this.initSwiper()
    },
    '$store.state.ui.galleryIndex': function () {
      this.updateSwiper()
    },
    '$store.state.design.isColor': function () {
      this.updateSwiper()
    },
    '$store.state.ui.tab': function (val) {
      if (val === 'tab-5') {
        setTimeout(() => {
          this.updateSwiper()
        }, 100)
      }
    },
    '$store.state.design.shareuc.designArea': function () {
      this.updateSwiper()
    }
  },
  computed: {
    list () {
      if (!this.$store.state.brand.brandJson) {
        return []
      } else {
        return this.$store.state.brand.brandJson.texture[this.$store.state.ui.galleryIndex].images[0][this.tags[this.selectedTagIndex]]
      }
    },
    tags () {
      if (!this.$store.state.brand.brandJson) {
        return []
      } else {
        return Object.keys(this.$store.state.brand.brandJson.texture[this.$store.state.ui.galleryIndex].images[0])
      }
    }
  },
  methods: {
    selectTag (index) {
      this.selectedTagIndex = index
      this.$store.state.ui.filter = this.tags[this.selectedTagIndex]
      this.updateSwiper()
    },
    updateSwiper: function () {
      if (!this.$store.state.ui.os.isPC) {
        this.updateSwiperPhone()
      } else {
        this.updateSwiperPC()
      }
    },
    updateSwiperPC: function () {
      this.swiper.slideNext(0)
      // if (this.lastGalleryIndex === this.$store.state.ui.galleryIndex) return
      var cols = 3
      const width = this.$refs.container.clientWidth
      let list
      if (this.$store.state.design.shareuc.designArea === 'umb_top') {
        list = this.list.slice(0, 1)
      } else {
        list = this.list
      }
      const group = Math.ceil(list.length / cols)
      var slides = []
      var lastGroup = list.length - cols * (group - 1)
      for (var i = 0; i < group; i += 1) {
        var slide = `<div style="width: ${width}px;height: ${width /
          cols}px;display: flex">`
        var count = i === group - 1 ? lastGroup : cols
        for (let j = 0; j < count; j++) {
          var pos = list[i * cols + j].pos || 'center'
          if (!list[i * cols + j].id.startsWith('color~')) {
            const suffix = list[i * cols + j].id.includes('IMG_') ? '.png' : '.jpg'
            let src = list[i * cols + j].id.replace(' ', '%20')
            if (list[i * cols + j].id.includes('-')) {
              src = src.replace('tex/', 'tex/thumb_')
            }
            var url = `url(${this_.$store.state.config.urls.galleryUrl}${src}${suffix}${this_.$store.getters.gallerySize})`
            slide += `<div style="flex: 0 0 ${100 /
              cols}%;background-position: ${pos};background-repeat: no-repeat;background-size: cover;background-image:
${url}" class="gallery~${list[i * cols + j].id}~${i * cols + j}"></div>`
          } else {
            var color = list[i * cols + j].id.replace('color~', '#')
            slide += `<div style="flex: 0 0 ${100 /
              cols}%;background-position: ${pos};background-repeat: no-repeat;background-size: cover;background-color:
${color}" class="gallery~${list[i * cols + j].id}~${i * cols + j}"></div>`
          }
        }
        slide += '</div>'
        slides.push(slide)
      }
      this.swiper.virtual.removeAllSlides()
      if (this.list.length > 0) {
        this.swiper.virtual.appendSlide(slides)
      }
      this.lastGalleryIndex = this.$store.state.ui.galleryIndex
    },
    updateSwiperPhone: function () {
      this.cols = window.innerWidth / (this.parentHeight / this.row)
      let list
      if (this.$store.state.design.shareuc.designArea === 'umb_top') {
        list = this.list.slice(0, 1)
      } else {
        list = this.list
      }
      const group = Math.ceil(list.length / this.row)
      const itemWidth = this.parentHeight / this.row
      var slides = []
      var lastGroup = list.length - this_.row * (group - 1)
      for (var i = 0; i < group; i += 1) {
        var slide = `<div style="width: ${itemWidth}px;height: ${this_.row *
          itemWidth}px;display: flex;flex-direction: column">`
        var count = i === group - 1 ? lastGroup : this_.row
        for (let j = 0; j < count; j++) {
          if (!list[i * this_.row + j].id.startsWith('color~')) {
            const suffix = list[i * this_.row + j].id.includes('IMG_') ? '.png' : '.jpg'
            let src = list[i * this_.row + j].id.replace(' ', '%20')
            if (list[i * this_.row + j].id.includes('-')) {
              src = src.replace('tex/', 'tex/thumb_')
            }
            var url = `${this_.$store.state.config.urls.galleryUrl}${src}${suffix}${this_.$store.getters.gallerySize}`
            slide += `<div style="flex: 0 0 ${100 /
              this_.row}%;height: ${itemWidth}px;background-position: bottom;background-repeat: no-repeat;background-size:
cover;background-image: url(${url})" class="gallery~${
              list[i * this_.row + j].id
            }~${i * this_.row + j}"></div>`
          } else {
            var color = list[i * this_.row + j].replace('color~', '#')
            slide += `<div style="flex: 0 0 ${100 /
              this_.row}%;height: ${itemWidth}px;background-position: bottom;background-repeat: no-repeat;background-size:
cover;background-color: ${color}" class="gallery~${
              list[i * this_.row + j].id
            }~${i * this_.row + j}"></div>`
          }
        }
        slide += '</div>'
        slides.push(slide)
      }
      this.swiper.virtual.removeAllSlides()
      if (this.list.length > 0) {
        this.swiper.virtual.appendSlide(slides)
      }
    },
    initSwiper: function () {
      if (!this.$store.state.ui.os.isPC) {
        this.initSwiperPhone()
      } else {
        this.initSwiperPC()
      }
      this.lastGalleryIndex = this.$store.state.ui.galleryIndex
    },
    initSwiperPC: function () {
      var cols = 3
      const width = this.$refs.container.clientWidth
      const height = this.$refs.container.clientHeight
      let list
      if (this.$store.state.design.shareuc.designArea === 'umb_top') {
        list = this.list.slice(0, 1)
      } else {
        list = this.list
      }
      const group = Math.ceil(list.length / cols)
      const rows = height / (width / cols)
      this.swiper = new Swiper('.swiper-gallery', {
        on: {
          // 点击图库
          click: e => {
            var className = e.target.className
            if (!className.startsWith('gallery~')) return
            var texName = className.split('~')[1]
            var index = Number(className.split('~')[2])
            // console.log('点击图库:', texName, index)
            if (this.showEmoji) {
              console.log('emoji:', texName)
            } else {
              if (texName.startsWith('pantone')) {
                this.$store.state.ui.colorType = 'umb'
                this.$emit('getLastColor')
                this.$store.state.design.shareuc.currentColor = ''
                this.$router.push('/color')
              } else {
                // region 图库
                if (texName.startsWith('color~')) {
                  this.$parent.changePatchColor(texName.replace('color~', '#'))
                } else {
                  const suffix = texName.includes('IMG_') ? '.png' : '.jpg'
                  var src = `${this.$store.state.config.urls.galleryUrl}${texName}${suffix}${this.$store.getters.textureSize}`
                  this.$emit('changePatchTexture', {
                    src: src,
                    texName: texName,
                    texHeight: 0,
                    realSizeY: 0,
                    pixel: this.list[index].pixel || 72,
                    isLogo: suffix === '.png'
                  })
                }
                // endregion
              }
            }
          }
        },
        direction: 'vertical',
        slidesPerView: rows,
        centeredSlides: false,
        spaceBetween: 0,
        virtual: {
          slides: (function () {
            var slides = []
            var lastGroup = list.length - cols * (group - 1)
            for (var i = 0; i < group; i += 1) {
              var slide = `<div style="width: ${width}px;height: ${width /
                cols}px;display: flex">`
              var count = i === group - 1 ? lastGroup : cols
              for (let j = 0; j < count; j++) {
                var pos = list[i * cols + j].pos || 'center'
                if (!list[i * cols + j].id.startsWith('color~')) {
                  const suffix = list[i * cols + j].id.includes('IMG_') ? '.png' : '.jpg'
                  let src = list[i * cols + j].id.replace(' ', '%20')
                  if (list[i * cols + j].id.includes('-')) {
                    src = src.replace('tex/', 'tex/thumb_')
                  }
                  var url = `url(${
                    this_.$store.state.config.urls.galleryUrl
                  }${src}${suffix}${
                    this_.$store.getters.gallerySize
                  })`
                  slide += `<div style="flex: 0 0 ${100 /
                    cols}%;background-position: ${pos};background-repeat: no-repeat;background-size: cover;background-image:
${url}" class="gallery~${list[i * cols + j].id}~${i * cols + j}"></div>`
                } else {
                  var color = list[i * cols + j].id.replace('color~', '#')
                  slide += `<div style="flex: 0 0 ${100 /
                    cols}%;background-position: ${pos};background-repeat: no-repeat;background-size: cover;background-color:
${color}" class="gallery~${list[i * cols + j].id}~${i * cols + j}"></div>`
                }
              }
              slide += '</div>'
              slides.push(slide)
            }
            return slides
          })()
        }
      })

      if (this.$refs.swiper) {
        this.$refs.swiper.addEventListener('wheel', e => {
          if (e.deltaY < 0) {
            // 向上
            if (this.swiper) {
              this.swiper.slidePrev(3)
            }
          } else {
            // 向下
            if (this.swiper) {
              this.swiper.slideNext(3)
            }
          }
        })
      }
    },
    initSwiperPhone: function () {
      this.cols = window.innerWidth / (this.parentHeight / this.row)
      let list
      if (this.$store.state.design.shareuc.designArea === 'umb_top') {
        list = this.list.slice(0, 1)
      } else {
        list = this.list
      }
      const group = Math.ceil(list.length / this.row)
      const itemWidth = this.parentHeight / this.row
      this.swiper = new Swiper('.swiper-gallery', {
        on: {
          // 点击图库
          click: e => {
            var className = e.target.className
            if (!className.startsWith('gallery~')) return
            var texName = className.split('~')[1]
            var index = Number(className.split('~')[2])
            // console.log('点击图库:', texName, index)
            if (this.showEmoji) {
              console.log('emoji:', texName)
            } else {
              if (texName.startsWith('pantone')) {
                this.$store.state.ui.colorType = 'umb'
                this.$emit('getLastColor')
                this.$store.state.design.shareuc.currentColor = ''
                this.$router.push('/color')
              } else {
                // region 图库
                if (texName.startsWith('color~')) {
                  this.$parent.changePatchColor(texName.replace('color~', '#'))
                } else {
                  const suffix = texName.includes('IMG_') ? '.png' : '.jpg'
                  var src = `${this.$store.state.config.urls.galleryUrl}${texName}${suffix}${this.$store.getters.textureSize}`
                  this.$emit('changePatchTexture', {
                    src: src,
                    texName: texName,
                    texHeight: 0,
                    realSizeY: 0,
                    pixel: this.list[index].pixel || 72,
                    isLogo: suffix === '.png'
                  })
                }
                // endregion
              }
            }
          }
        },
        // direction: 'vertical',
        slidesPerView: this.cols,
        centeredSlides: false,
        spaceBetween: 0,
        virtual: {
          slides: (function () {
            var slides = []
            var lastGroup = list.length - this_.row * (group - 1)
            for (var i = 0; i < group; i += 1) {
              var slide = `<div style="width: ${itemWidth}px;height: ${this_.row *
                itemWidth}px;display: flex;flex-direction: column">`
              var count = i === group - 1 ? lastGroup : this_.row
              for (let j = 0; j < count; j++) {
                if (!list[i * this_.row + j].id.startsWith('color~')) {
                  const suffix = list[i * this_.row + j].id.includes('IMG_') ? '.png' : '.jpg'
                  let src = list[i * this_.row + j].id.replace(' ', '%20')
                  if (list[i * this_.row + j].id.includes('-')) {
                    src = src.replace('tex/', 'tex/thumb_')
                  }
                  var url = `${this_.$store.state.config.urls.galleryUrl}${src}${suffix}${
                    this_.$store.getters.gallerySize
                  }`
                  slide += `<div style="flex: 0 0 ${100 /
                    this_.row}%;height: ${itemWidth}px;background-position: center;background-repeat: no-repeat;background-size:
cover;background-image: url(${url})" class="gallery~${
                    list[i * this_.row + j].id
                  }~${i * this_.row + j}"></div>`
                } else {
                  var color = list[i * this_.row + j].replace('color~', '#')
                  slide += `<div style="flex: 0 0 ${100 /
                    this_.row}%;height: ${itemWidth}px;background-position: center;background-repeat: no-repeat;background-size:
cover;background-color: ${color}" class="gallery~${
                    list[i * this_.row + j].id
                  }~${i * this_.row + j}"></div>`
                }
              }
              slide += '</div>'
              slides.push(slide)
            }
            return slides
          })()
        }
      })
    }
  },
  mounted () {
    this_ = this
    // if (this.$store.state.ui.os.isPC) {
    //   this.filtersHeight = parseFloat(getComputedStyle(this.$refs.filters).height)
    // }
    this.parentHeight = parseFloat(getComputedStyle(this.$parent.$el).height) - this.filtersHeight
    if (this.$store.state.brand.loadJsonComplete) {
      this.initSwiper()
    }
  },
  activated () {
    this.$store.state.ui.showFilters = false
  }
}
</script>

<style lang="scss" scoped>
.swiper-gallery-phone {
  width: 100vw;
  height: 12vh;
}
.swiper-gallery-pc {
  width: 27vw;
}
</style>
